document.addEventListener('DOMContentLoaded', () => {
  initProductDrawer();
});

function initProductDrawer() {
    const drawer = document.getElementById('product-drawer');
    const overlay = document.getElementById('menu-overlay');
    const openBtns = document.querySelectorAll('.open-product-drawer');
    const closeBtn = document.getElementById('close-product-drawer');
  
    if (!drawer || !overlay || !openBtns.length) return;
  
    const open = () => {
      drawer.classList.remove('translate-x-full');
      overlay.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    };
  
    const closeDrawer = () => {
      drawer.classList.add('translate-x-full');
      overlay.classList.add('hidden');
      document.body.style.overflow = '';
    };
  
    document.addEventListener('cart:updated', (event) => {
      const submittedForm = event.detail?.form;
    
      if (submittedForm && drawer.contains(submittedForm)) {
        closeDrawer();
      }
    });
    
    openBtns.forEach((btn) => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();

        const handle = btn.dataset.productHandle;
        if (!handle) return;
        
        const variantId = btn.dataset.productVariantId;

        await loadProductIntoDrawer(handle, variantId);
        open();
      });
    });
  
    closeBtn?.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
  }
  
  async function loadProductIntoDrawer(handle, variantId) {
    const header = document.querySelector('#product-drawer-header');
    if (!header) return;
    
    const container = document.querySelector('#product-drawer-content');
    if (!container) return;
    
    const sticky = document.querySelector('#product-drawer-sticky');
    if (!sticky) return;
  
    container.innerHTML = 'Chargement…';
  
    const response = await fetch(`/products/${handle}?variant=${variantId}&view=drawer`);
    const html = await response.text();
  
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const h = doc.querySelector('.product-drawer-header');
    const c = doc.querySelector('.product-drawer-inner');
    const s = doc.querySelector('.product-drawer-sticky-inner');
    
    header.innerHTML = h ? h.innerHTML : 'Erreur';
    container.innerHTML = c ? c.innerHTML : 'Erreur';
    sticky.innerHTML = s ? s.innerHTML : 'Erreur';
    
    emblaJsInit(); // from embla-init.js
    productJsInit(); // from product.js
    globalInitAddToCart(); //from global.js

}
  